<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--统计信息-->
                    <div class="plan-chart">
                        <div class="pc-name">采购单概况：</div>
                        <div class="pc-text">
                            <span style="margin-left: 70px">新增：{{count.news|formatNumber}}</span>
                            <span style="margin-left: 120px">待审批：{{count.auditing|formatNumber}}</span>
                        </div>
                    </div>

                    <!--表格标题-->
                    <div class="mycard-title">采购单列表</div>

                    <!--表格、分页-->
                    <el-table :data="main$data" v-loading="main$loading" size="medium">
                        <el-table-column type="index" label="序号" width="80" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="cgdNo" label="采购单号" width="260" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="orderDay" label="生成时间" width="260" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="whName" label="仓库" width="180" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="statesCn" label="状态" width="180" align="center" header-align="center"> </el-table-column>
                        <el-table-column align="center" header-align="center">
                            <template slot-scope="scope">
                                <el-button type="text" class="mylinkbtn" @click="table_check(scope.row)" :disabled="scope.row.states != 1">审批</el-button>
                                <el-button type="text" class="mylinkbtn" @click="table_detail(scope.row)" >查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <el-pagination style="float: right;margin: 14px"
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                        <div style="clear: both;"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 概况
            count:{ },
            // 表格数据
            main$query_dataSource: '',
            main$query_cgdNo: '',
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: []
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/purchase/getList'), {
                page: self.main$curr_page,
                rows: self.main$page_size,
                dataSource: self.main$query_dataSource,  // 数据来源
                cgdNo: self.main$query_cgdNo,            // 采购单编号
            },{xPostType:'form'}).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        table_detail: function (row) {
            this.$router.push({path: '/purchase/plan-detail', query: {id: row.id}});
        },
        table_check: function (row) {
            let self = this;
            self.xEui.confirm('提示', '请选择审批意见', ['通过', function () {
                self.postAudit(row.id, '6', function () {
                    self.fetchData()
                })
            }], ['不通过', function (action) {
                if (action == 'cancel') {
                    self.postAudit(row.id, '1', function () {
                        self.fetchData()
                    })
                }
            }])
        },
        postAudit: function (id, states/*1不通过 6通过*/,cb) {
            let self = this
            self.xEui.myloading('审核中...')
            self.xFetch.post(self.xApi('/robot/purchase/audit'), {
                id: id,
                states: states
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else {
                    self.xEui.msg_success('审核完成')
                    cb && cb();
                }
            });
        }
    },
    created: function(){
        let self = this

        // 概况
        self.xFetch.post(self.xApi('/robot/purchase/getCount'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.count = res.data.data;
        });

        // 表格数据
        self.fetchData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mycard-title{ font-size: 16px;margin-bottom: 20px }
    /*plan-chart*/
    .plan-chart{ border-bottom: 1px solid #EAEAEA;padding-bottom: 20px;margin-bottom: 20px }
    .plan-chart .pc-name{ display: inline-block; font-size: 16px;color: #707090; }
    .plan-chart .pc-text{ display: inline-block; font-size: 16px;color: #333;}
</style>



// WEBPACK FOOTER //
// src/views/purchase/plan.vue